var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon d-flex align-items-center",class:_vm.name+'icon'},[_c('div',{staticClass:"icon-wrapper",class:_vm.classes},[_c('div',{staticClass:"icon-inner icon-regular"},[_c(_vm.getIconComponent,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }